import React, { useRef, useEffect } from 'react';
import {Grid,Row,Col} from 'react-flexbox-grid';
import { rhythm } from "../utils/typography.js";
import * as dc from "dc";
import Select from 'react-select'

import { Activities } from "./row_activities";
import { Grades } from "./row_grades";
import { Subjects } from "./row_subject";
import { Teachers } from "./row_teacher";
import { GradingRubric } from "./row_grade_rubric";
//import { StudentGrades } from "./row_student_grades";
//import { MonthGrades } from "./row_student_grades_by_month";
// import { TypeChart } from "./rowChart";
// import { BunitChart } from "./rowChart2";
// import { TopicChart } from "./rowChart3";
// import { SLevelChart } from "./rowChart4";
// import { AgentChart } from "./rowChart5";
import { BarChart1 } from "./barChart1";
import { BarChart2 } from "./barChart2";
import { BarChartDay } from "./barChartDay";
// //import { SeriesChart } from "./seriesChart";
// import { RangeChart } from "./rangeChart";
// import { HeatMap }  from "./heatMap";
 import { TotalEntries }  from "./totalChart";
 import { TotalWords }  from "./totalWordsChart";
 import { TotalVocabulary }  from "./totalVocabularyChart";
 import { TotalAssigments }  from "./totalAssignmentsChart";
 import { TotalStudents }  from "./totalStudentsChart";
 //import { StudentGrades1 }  from "./row_student_grades_by_month";
 import { StudentGradesGroup } from "./studentGradesGroup";
 //import { Metrics } from "./metrics";
// import { AvgWaitTotal }  from "./avgWaitChart";
// import { AvgConversationTotal }  from "./avgWConversationTotal";
// import { ServiceLevelTotal }  from "./serviceLevelChart";
//import { TagChart }  from "./tagChart";
//import TagList from './tagList';
import { DataContext } from "./cxContext";
import { css } from 'glamor';

export const Dashboard = (props)=>{

  const style = css({
      padding:'0.5rem 1.2rem',
    //  marginRight:'0.2rem'
  })

  const bgd = css({
      backgroundColor: '#065FE5'
  })

  const bgd1 = css({
      backgroundColor: '#2B4E7B'
  })

  const bgd2 = css({
      backgroundColor: '#077CA0'
  })

  const bgd3 = css({
      backgroundColor: '#97D318'
  })

  const bgd4 = css({
      backgroundColor: '#FFA826'
  })

  const tagsStyle = {
      //padding:'1rem',
      marginTop:'15px',
      //marginLeft: '100px',
      textAlign: 'center',
      width: '100%'
  }

  const tagsBgdStyle = {
    backgroundColor: '#f7f8fc',
    margin: '10px',
    display: 'flex',
    flexDirection: 'row'
  }

  const tagStyle = {
    // margin: '0',
    padding: 0
  }

  const totalStyle = css({
      marginBottom: rhythm(0.64)
  })

  const metricStyle = css({
    marginRight: rhythm(1.0),
    marginLeft : rhythm(0.05),
    marginTop: rhythm(0.001),
    padding: rhythm(0.2),
    display: "flex",
    cursor:'pointer',
    fontSize: '14px',
    alignItems: 'flex-end',
    width: '100%'
  });

  const buttonStyle = css({
    marginRight: rhythm(0.2),
    marginLeft : rhythm(0.05),
    padding: '0.2em 1em',
    border: 'none',
     borderRadius:' 2em',
     boxSizing: 'border-box',
     textDecorationdecoration: 'none',
     color:'#FFFFFF',
     //backgroundColor:'#4eb5f1',
     textAlign: 'center',
    cursor: 'pointer',
    ':hover': {
      opacity: 0.7
    }
  })

  const optionsStyle = css({
    // marginRight: rhythm(0.2),
    // marginTop: rhythm(0.1),
    padding: rhythm(0),
    display: "inline",
    cursor:'pointer',
    float:'right',
    fontSize: '12px',
    maxWidth: '160px',
    maxHeight: '25px'
  });

  const spanStyle = css({
    // marginRight: rhythm(0.2),
    // marginTop: rhythm(0.1),
    marginLeft: rhythm(0.3),
    padding: rhythm(0.3),


    fontSize: '12px',
    // maxWidth: '160px',
    // maxHeight: '25px'
  });

  const labelStyle = css({
    // marginRight: rhythm(0.2),
    // marginTop: rhythm(0.1),
    // marginLeft: rhythm(0.3),
    // padding: rhythm(0.3),


    fontSize: '17px',
    //fontWeight: '500'
    // maxWidth: '160px',
    // maxHeight: '25px'
  });

  const options = ["# of Entries", "Total # of Words", "Average # of Words", "# of Assignments"];
  let selection;

//let colors = ['orange', 'red', 'blue', 'purple']

  const [metric, setMetric] = React.useState("# of Entries");
  const [reset, setReset]  = React.useState(false);
  //const [studentGradesmetric, setStudentGradesmetric] = React.useState("# of Students");

  const selectMetric = (option) => {
    //setStudentGradesmetric(option)
    setMetric(option);
    // if(selection.current) {
    //   selection.current.selectedOption = { value: option, label: option };
    // }
    // console.log("select "+selection.current.value +" "+selection.current.index)
  }

  const ResetButton = props => {
    const style = css({
      fontSize: "11px",
      marginRight: rhythm(-0.02),
      //marginBottom: rhythm(0.2),
      padding: rhythm(0.2),
      paddingLeft: rhythm(0.2),
      display: "inline",
      cursor:'pointer',
      float:'right',
      '&:hover':{
          background: "#3E3E3E",
          color: "#fff"
      }
    });
    return (
      <span  {...style} onClick={() => {
          dc.filterAll();
          dc.redrawAll();
        }}
      >
        Reset All
      </span>
    );
  };

  const ResetButton1 = props => {
    const style = css({
      fontSize: "9px",
      marginRight: rhythm(-0.02),
      marginTop: rhythm(0.15),
      padding: rhythm(0.1),
      paddingLeft: rhythm(0.2),
      display: "inline",
      cursor:'pointer',
      float:'right',
      '&:hover':{
          background: "#ccc",
          //color: "#fff"
      }
    });
    return (
      <span  {...style} onClick={() => {
        //console.log("reset "+reset)
          setReset(true);
          //console.log("reset after setReset "+reset)
          setTimeout(() => {
            setReset(false)
            //console.log("reset after setTimeout "+reset)
          }, 50);
        }}
      >
        Reset
      </span>
    );
  };

  const Metrics = props => (
    <div {...metricStyle}>
      <div className="dummy"/>
      { options.map((option,i) => {
        return (<button key={i} index={i} {...buttonStyle}  className={'button'+i}
         onClick={(e) => selectMetric(options[i], e)} >{options[i]}</button>)
      })}
      <ResetButton />
    </div>
  )



  // const Options = props => {
  //   selection = useRef(null);
  //
  //   const listOptions = [
  //     { value: '# of Entries', label: '# of Entries' },
  //     { value: 'Total # of Words', label: 'Total # of Words' },
  //     { value: 'Average # of Words', label: 'Average # of Words' },
  //     { value: '# of Assignments', label: '# of Assignments' },
  //     { value: '# of Students', label: '# of Students' },
  //   ];
  //   const style = css({
  //     marginRight: rhythm(0.2),
  //     marginTop: rhythm(0.1),
  //     padding: rhythm(0.1),
  //     marginLeft: rhythm(1.8),
  //     display: "inline",
  //     cursor:'pointer',
  //     float:'right',
  //     fontSize: '12px',
  //     maxWidth: '160px',
  //     width: '160px'
  //   });
  //
  //   const customStyles = {
  //     option: (provided, state) => ({
  //       ...provided,
  //       width: state.selectProps.width,
  //       //borderBottom: '1px dotted pink',
  //       //color: state.isSelected ? 'red' : 'blue',
  //       padding: 5,
  //       width: 160,
  //       fontSize: '12px'
  //     }),
  //     control: () => ({
  //       // none of react-select's styles are passed to <Control />
  //        width: '160px',
  //        marginLeft: 40,
  //       // maxHeight: 35,
  //        fontSize: '12px',
  //       // borderRadius: 8,
  //       // bordeColor: '#111'
  //     }),
  //     // singleValue: (provided, state) => {
  //     //   const opacity = state.isDisabled ? 0.5 : 1;
  //     //   const transition = 'opacity 300ms';
  //     //
  //     //   return { ...provided, opacity, transition };
  //     // }
  //   }
  //
  //   //console.log(props.title+" metric inside chart "+ props.metric)
  //   //<div  {...optionsStyle}><Options   />  </div> options to be included
  //
  //
  //   const title = props.title;
  //
  //   const handleChange = (selectedOption) => {
  //     selection.current.selectedOption = selectedOption;
  //     setStudentGradesmetric(selectedOption.value);
  //   }
  //
  //   return (
  //     <Select   ref={selection}  className="react-select-container" classNamePrefix="react-select"
  //       options={listOptions}
  //       value={{ value: studentGradesmetric, label: studentGradesmetric }}
  //       onChange={ handleChange }
  //       >
  //
  //     </Select>
  //   )
  // }



  return(
    <div {...style}>
      <DataContext >
        <Grid fluid>
          <Row>
          <Col md={6}>

          </Col>
            <Col md={6}>
              <Metrics />
            </Col>
          </Row>
            <Row >
              <Col md={6}  {...style}>
                <Row>
                  <Col md={4} >
                    <div {...bgd}>
                      <TotalEntries title="Student Entries" />
                    </div>
                  </Col>
                  <Col md={4} >
                    <div {...bgd1}>
                      <TotalWords title="Words Written"/>
                    </div>
                  </Col>
                  <Col md={4} >
                    <div {...bgd2}>
                      <TotalVocabulary title="Word Bank Used"/>
                    </div>
                  </Col>
                </Row>
                <Row {...totalStyle}>
                  <Col md={4} >
                    <div {...bgd3}>
                      <TotalAssigments title="Assignments"/>
                    </div>
                  </Col>
                  <Col md={4} >
                    <div {...bgd4}>
                      <TotalStudents title="Students"/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={4} >
                    <Row>
                      <BarChart2 title="By Year"  type="barChart" className="barChart" metric={metric} showMetricsSelector={true}/>
                    </Row>
                  </Col >
                  <Col md={8} >
                    <Row>
                      <BarChart1 title="By Month"  type="barChart" className="barChart" metric={metric} showMetricsSelector={true}/>
                    </Row>
                  </Col >
                </Row>
                <Row>
                  <BarChartDay title="By Day"  type="barChart" className="barChart" metric={metric} showMetricsSelector={true}/>
                </Row>
              </Col >
              <Col md={3} {...style}>
                <Row>
                  <Activities title="Activities"  type="rowchart" className="rowchart" metric={metric} showMetricsSelector={true}/>
                </Row>
                <Row>
                  <Grades title="Grade"  type="rowchart" className="rowchart" metric={metric}  showMetricsSelector={true}/>
                </Row>
                <Row>
                  <Subjects title="Subject"  type="rowchart" className="rowchart" metric={metric} showMetricsSelector={true}/>
                </Row>
              </Col>

              <Col md={3}  {...style}>
                <Row>
                  <Teachers title="Teacher" type="rowchart" className="rowchart" metric={metric} showMetricsSelector={true}/>
                </Row>
                <Row>
                  <GradingRubric title="Grading Rubric" type="rowchart" className="rowchart" metric={metric} showMetricsSelector={true}/>
                </Row>
              </Col >
            </Row>
            <Row>
              <label {...labelStyle} >Score Distribution   <span {...spanStyle}># of Students</span><ResetButton1 /></label>
            </Row>
            <Row>
              <StudentGradesGroup  title="Student Grades" metric={"# of Students"} showMetricsSelector={true} reset={reset}/>
            </Row>
          </Grid>
        </DataContext>
      </div>
  )
}
